import { useCallback, useEffect } from "react";
import { LayerTypePrintableProps } from "react-migration/layouts/map/Multilayer/types";
import { InsightsSummaryAccordion } from "./InsightsSummaryAccordion";
import { useSummaryLoadingState } from "./useSummaryLoadingState";

export function InsightSummaryPrintable({ layer, selection, onLoaded, onUnmount }: LayerTypePrintableProps) {
  const [summaryLoadingMap, setSummaryLoading] = useSummaryLoadingState();
  const { LayerSummary } = layer.layerType;

  useEffect(() => {
    if (Object.keys(summaryLoadingMap).includes(layer.id) && !summaryLoadingMap[layer.id]) {
      onLoaded();
    }
  }, [layer.id, onLoaded, summaryLoadingMap]);

  useEffect(() => () => onUnmount(), [onUnmount]);

  const onLoadingChange = useCallback(
    (loadingState: boolean) => setSummaryLoading(layer.id, loadingState),
    [layer.id, setSummaryLoading]
  );

  if (!LayerSummary) return null;

  return (
    <InsightsSummaryAccordion>
      <InsightsSummaryAccordion.Item
        key={layer.id}
        value={layer.id}
        title={LayerSummary.title ?? layer.title}
        icon={LayerSummary.icon}
        loading={summaryLoadingMap[layer.id]}
        hideLink={true}
      >
        <LayerSummary layer={layer} selection={selection} onLoadingChange={onLoadingChange} print={true} />
      </InsightsSummaryAccordion.Item>
    </InsightsSummaryAccordion>
  );
}
